import { useCallback } from 'react'

import { InvoiceDocumentType } from '@features/invoices/enums/invoiceDocumentType'
import { useInvoiceComplianceMode } from '@features/invoices/hooks/useInvoiceComplianceMode'
import type { Invoice } from '@features/invoices/types/invoices/invoice'
import { isDocumentEligibleForEInvoice } from '@features/invoices/utils/eInvoices/isDocumentEligibleForEInvoice'
import { useUserOrganization } from '@modules-deprecated/app/organization'

import { hasEInvoiceSentEvent } from '../utils/hasEInvoiceSentEvent'

const REFETCH_INTERVAL_MS = 30000

export const useInvoiceShouldRefetch = (
  documentType: InvoiceDocumentType,
): ((data: { data: Invoice } | undefined) => number | false) => {
  const { isFrenchComplianceMode, isLoading: isModeLoading } = useInvoiceComplianceMode()
  const { isLoading: isOrganizationLoading } = useUserOrganization()

  return useCallback(
    (data) => {
      const invoice = data?.data
      if (isModeLoading || isOrganizationLoading || !invoice) {
        return false
      }

      const hasSentEvent = hasEInvoiceSentEvent(invoice.status?.events ?? [])
      const isEligibleForEInvoice = isDocumentEligibleForEInvoice({
        contactCountry: invoice.customer?.address?.country,
        contactType: invoice.customer?.customerType,
        documentStatus: invoice.status?.status,
        documentType,
        isOrganizationFrench: isFrenchComplianceMode,
        isCustomerPublicEntity: invoice.customer?.isPublicEntity,
      })

      return hasSentEvent && isEligibleForEInvoice ? REFETCH_INTERVAL_MS : false
    },
    [documentType, isFrenchComplianceMode, isModeLoading, isOrganizationLoading],
  )
}
